import Immutable from 'seamless-immutable';
import { defaults } from 'uploader';

const uiConfigKeys = [
  // the params UI cares about
  'cloudName',
  'inlineMode',
  'sources',
  'defaultSource',
  'multiple',
  'googleApiKey',
  'googleDriveClientId',
  'dropboxAppKey',
  'facebookAppId',
  'instagramServer',
  'searchBySites',
  'searchByRights',
  'autoMinimize',
  'useTagsCallback',
  'useUploadPresetsCallback',
  'text',
  'language',
  'maxFiles',
  'showAdvancedOptions',
  'showPoweredBy',
  'showCompletedButton',
  'showUploadMoreButton',
  'cropping',
  'croppingAspectRatio',
  'croppingDefaultSelectionRatio',
  'croppingShowDimensions',
  'croppingCoordinatesMode',
  'croppingShowBackButton',
  'minImageWidth',
  'minImageHeight',
  'maxImageWidth',
  'maxImageHeight',
  'theme',
  'singleUploadAutoClose',
  'maxFileSize',
  'maxImageFileSize',
  'maxVideoFileSize',
  'maxRawFileSize',
  'showSkipCropButton',
  'shutterstockServer',
  'istockServer',
  'gettyServer',
  'clientAllowedFormats',
  'tabInsideWidget',
  'newTlsDomain',
];

export const takeUiParams = (data) =>
  Object.keys(data)
    .filter((key) => ~uiConfigKeys.indexOf(key)) // only leave the relevant ui params
    .reduce((res, key) => {
      res[key] = data[key];
      return res;
    }, {});

export default () =>
  Immutable({
    ...takeUiParams(defaults),
    __record: 'WidgetConfigRecord',
  });
